import ErrorBoundary from "components/ErrorBoundary";
import React, { useEffect, useState } from "react";
import SearchDashboard from "./SearchDashboard";
import {
  Card,
  CardBody,
  CardHeader,
  CardTitle,
  Col,
  Container,
  Row,
} from "reactstrap";
import EncountersDrawer from "./Components/EncountersDrawer";
import useContextService from "hooks/useContextService";
import FinacialIcon from "../../assets/icon/DashboardFinacial.svg";
import DashboardProgram from "../../assets/icon/DashboradHelathIcon.svg";
import DashboardHealthimages from "../../assets/icon/DashboardHealthimages.svg";
import DashboardHelath1 from "../../assets/icon/HealthImage2.svg";
import DashboardHelath2 from "../../assets/icon/HealthImg2.svg";
import Programover from "./Components/Programover";
import { dateFormate } from "utils/columns";
import CTooltip from "react-tooltip-lite";
import DrugSpend from "./Components/DrugSpend";
import useAxios from 'hooks/useAxios';
import FaxOverview from "./Components/FaxOverview";
import TopDrugs from "./Components/TopDrugs";
import WholesalerSpend from "./Components/WholesalerSpend";
import Drugutlization from "./Drugutlization";
import Drawer from "components/Drawer";
import Loader from "components/Loader";

let defaultValue = {
  dateRangeID: 4,
};

const Dashboard = (props) => {
  const API = useAxios();
  const { orgId } = props;
  const {
    states: { dashboard },
    setStates,
  } = useContextService();
  const [loading, setLoading] = useState(false);
  const { search, searchTerms, coveredEntities } = dashboard;
  const [selectsearch, setSelectSearch] = useState(false);
  const [drugutlization, setDrugutlization] = useState(false);
  const [months, setMonths] = useState();
  const [counterData, setCounterData] = useState({
    "financialSummary": [
      {
        "name": "TestedClaims Claims",
        "value": "-",
        "iconName": "Tested Claims",
        "tooltip": "All claims that flowed from Contract Pharmacy to Referrals+ that appear in the system, regardless of the status.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "CE Receivable",
        "value": "-",
        "iconName": "CE Receivable",
        "tooltip": "The receivable value (Total Paid - Dispensing Fee) on approved or higher status claims.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "340B Drug Cost",
        "value": "-",
        "iconName": "340B Drug Cost",
        "tooltip": "The 340B Drug Cost on approved or higher status claims.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Profit Loss",
        "value": "-",
        "iconName": "Profit Loss",
        "tooltip": "The profit or loss (Total Paid - Dispensing Fee - 340B Drug Cost) on approved or higher status claims.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "RCS Fee",
        "value": "-",
        "iconName": "RCS Fee",
        "tooltip": "The calculated RCS fee on approved or higher status claims.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Net Savings",
        "value": "-",
        "iconName": "Net Savings",
        "tooltip": "The net savings (Total Paid - Dispensing Fee - 340B Drug Cost - RCS Fee) on approved or higher status claims.",
        "recordsCount": 0,
        "recentReceivedDate": null
      }
    ],
    "programHealth": [
      {
        "name": "Encounter",
        "value": "-",
        "iconName": "Encounter",
        "tooltip": "Displays Encounter data from the last 30 days, including successful and failed records.",
        "recordsCount": 0,
        "recentReceivedDate": ""
      },
      {
        "name": "Queued Claims",
        "value": "-",
        "iconName": "Queued Claims",
        "tooltip": " The number of claims that passed all rule checks and are in Queued status to review for eligibility.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Pending Claims",
        "value": "-",
        "iconName": "Pending Claims",
        "tooltip": "The number of claims pending an inbound fax from a provider's office.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Approved Claims",
        "value": "-",
        "iconName": "Approved Claims",
        "tooltip": "The number of claims that have been approved and are pending submission to Contract Pharmacy to capture.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Approved-Sent to TPA Claims",
        "value": "-",
        "iconName": "Approved-Sent to TPA Claims",
        "tooltip": "The number of claims that have been approved and sent to Contract Pharmacy to capture.",
        "recordsCount": 0,
        "recentReceivedDate": null
      },
      {
        "name": "Replenished Claims",
        "value": "-",
        "iconName": "Replenished Claims",
        "tooltip": "The number of claims that have been replenished.",
        "recordsCount": 0,
        "recentReceivedDate": null
      }
    ]
  });
  const [inboundFaxCount, setInboundFaxCount] = useState();
  const [netSavings, setNetSavings] = useState();
  const [outboundFailedFaxCount, setOutboundFailedFaxCount] = useState();
  const [outboundFaxCount, setOutboundFaxCount] = useState();
  const [unmappedFaxCount, setUnmappedFaxCount] = useState();
  const [isOpen, setIsOpen] = useState(false);
  const [randNum, setRandNumber] = useState(0);
  const [top10Drugs, setTop10Drugs] = useState();
  const togglesDrawer = () => {
    setDrugutlization(!drugutlization);
  };
  const [startDateVAlue, setStartDateValue] = useState(null);
  const [endDateVAlue, setEndDateValue] = useState(null);

  useEffect(() => {
    if (drugutlization == true) {
      setDrugutlization(false)
    }
    handleReset()

  }, [orgId])

  const filesData = [
    {
      fileType: "Encounter",
      fileName: null,
      recordsCount: 4198,
      recentReceivedDate: "2025-03-19T00:00:00",
      days: 0,
      delayLoad: "N",
      delayedDate: "2025-03-17T00:00:00",
      singleCESelected: false,
      img: 1,
      fileType1: 1,
    },
    {
      fileType: "Queued Claims",
      fileName: null,
      recordsCount: 4,
      recentReceivedDate: "2025-03-19T00:00:00",
      days: 0,
      delayLoad: "N",
      delayedDate: "2025-03-17T00:00:00",
      singleCESelected: false,
      img: 1,
    },
    {
      fileType: "Pending Claims",
      fileName: null,
      recordsCount: 2,
      recentReceivedDate: "2025-03-10T11:22:27.427",
      days: 0,
      delayLoad: "N",
      delayedDate: null,
      singleCESelected: false,
      img: 1,
    },
    {
      fileType: "Approved Claims",
      fileName: null,
      recordsCount: 0,
      recentReceivedDate: "2025-03-20T12:26:52.36",
      days: 0,
      delayLoad: "N",
      delayedDate: null,
      singleCESelected: false,
      img: 2,
    },
    {
      fileType: "Approved - Sent to TPA",
      fileName: null,
      recordsCount: 0,
      recentReceivedDate: "2025-03-20T12:32:58.427",
      days: 0,
      delayLoad: "N",
      delayedDate: null,
      singleCESelected: false,
      img: 2,
    },
    {
      fileType: "Replenished Claims",
      fileName: null,
      recordsCount: 0,
      recentReceivedDate: "2025-03-20T12:32:58.427",
      days: 0,
      delayLoad: "N",
      delayedDate: null,
      singleCESelected: false,
      img: 2,
    },
  ];



  const onSearch = async (filter) => {
    setLoading(true); // Show the loader
    const fetchRequests = [
      fetchLineGraphs(filter),
      fetchClaimCount(filter),
      fetchMonths(filter.dateRangeValue),
      fetchBarGraphs(filter),
    ];
    try {
      const results = await Promise.allSettled(fetchRequests); // Run all requests concurrently
      console.log(results, "results")
    } catch (error) {
      console.error('Error fetching data:', error);
    } finally {
      setLoading(false); // Hide the loader when all requests are done
    }
  };


  const fetchMonths = async (dateRangeID) => {
    let tenantID = coveredEntities.tenantID;
    if (!tenantID) {
      return null;
    }
    try {
      const { data } = await API.get(
        `RCMDashBoard/${tenantID}/DashBoard/getmonths/${dateRangeID ? dateRangeID : 4}`,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        setMonths(data);
      } else {
        setMonths([]);
      }
    } catch (error) { }

  };

  const fetchClaimCount = async (filters) => {
    const { dateRangeValue, CPIds, CEIds, PHIds } = filters;
    let tenantID = coveredEntities.tenantID;
    if (!tenantID) {
      return null;
    }
    var payload = {};
    try {
      // pharmacyIDS ? payload.phids = pharmacyIDS : payload.phids = []
      payload.daterangeid = parseInt(dateRangeValue);
      payload.cpids = CPIds;
      payload.ceids = CEIds;
      payload.phids = PHIds;
      const { data } = await API.post(
        `RCMDashBoard/${tenantID}/DashBoard/getcounts/${coveredEntities.coveredEntityID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        setCounterData(data);
      } else {
        setCounterData({
          "financialSummary": [
            {
              "name": "TestedClaims Claims",
              "value": "-",
              "iconName": "Tested Claims",
              "tooltip": "All claims that flowed from Contract Pharmacy to Referrals+ that appear in the system, regardless of the status.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "CE Receivables",
              "value": "-",
              "iconName": "CE Receivables",
              "tooltip": "The receivable value (Total Paid - Dispensing Fee) on approved or higher status claims.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "340B Drug Cost",
              "value": "-",
              "iconName": "340B Drug Cost",
              "tooltip": "The 340B Drug Cost on approved or higher status claims.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Profit Loss",
              "value": "-",
              "iconName": "Profit Loss",
              "tooltip": "The profit or loss (Total Paid - Dispensing Fee - 340B Drug Cost) on approved or higher status claims.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "RCS Fee",
              "value": "-",
              "iconName": "RCS Fee",
              "tooltip": "The calculated RCS fee on approved or higher status claims.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Net Savings",
              "value": "-",
              "iconName": "Net Savings",
              "tooltip": "The net savings (Total Paid - Dispensing Fee - 340B Drug Cost - RCS Fee) on approved or higher status claims.",
              "recordsCount": 0,
              "recentReceivedDate": null
            }
          ],
          "programHealth": [
            {
              "name": "Encounter",
              "value": "-",
              "iconName": "Encounter",
              "tooltip": "Displays Encounter data from the last 30 days, including successful and failed records.",
              "recordsCount": 0,
              "recentReceivedDate": ""
            },
            {
              "name": "Queued Claims",
              "value": "-",
              "iconName": "Queued Claims",
              "tooltip": " The number of claims that passed all rule checks and are in Queued status to review for eligibility.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Pending Claims",
              "value": "-",
              "iconName": "Pending Claims",
              "tooltip": "The number of claims pending an inbound fax from a provider's office.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Approved Claims",
              "value": "-",
              "iconName": "Approved Claims",
              "tooltip": "The number of claims that have been approved and are pending submission to Contract Pharmacy to capture.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Approved-Sent to TPA Claims",
              "value": "-",
              "iconName": "Approved-Sent to TPA Claims",
              "tooltip": "The number of claims that have been approved and sent to Contract Pharmacy to capture.",
              "recordsCount": 0,
              "recentReceivedDate": null
            },
            {
              "name": "Replenished Claims",
              "value": "-",
              "iconName": "Replenished Claims",
              "tooltip": "The number of claims that have been replenished.",
              "recordsCount": 0,
              "recentReceivedDate": null
            }
          ]
        });
      }
    } catch (error) { }
  };

  const fetchLineGraphs = async (filters) => {
    const { dateRangeValue, CPIds, CEIds, PHIds } = filters;
    let tenantID = coveredEntities.tenantID;
    if (!tenantID) {
      return null;
    }
    var payload = {};
    try {
      payload.daterangeid = parseInt(dateRangeValue);
      payload.cpids = CPIds;
      payload.ceids = CEIds;
      payload.phids = PHIds;
      const { data } = await API.post(
        `RCMDashboard/${tenantID}/Dashboard/getlinegraphvalues/${coveredEntities.coveredEntityID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        setInboundFaxCount(data.inboundFaxCount);
        setOutboundFailedFaxCount(data.outboundFailedFaxCount);
        setNetSavings(data.netSavings);
        setOutboundFaxCount(data.outboundFaxCount);
        setUnmappedFaxCount(data.unmappedFaxCount);
      } else {
        setInboundFaxCount([]);
        setOutboundFailedFaxCount([]);
        setOutboundFaxCount([]);
        setUnmappedFaxCount([]);
        setNetSavings([]);

      }
    } catch (error) { }
  };

  const fetchBarGraphs = async (filters) => {
    const { dateRangeValue, CPIds, CEIds, PHIds } = filters;
    let tenantID = coveredEntities.tenantID;
    if (!tenantID) {
      return null;
    }
    var payload = {};
    try {
      payload.daterangeid = parseInt(dateRangeValue);
      payload.cpids = CPIds;
      payload.ceids = CEIds;
      payload.phids = PHIds;
      const { data } = await API.post(
        `RCMDashBoard/${tenantID}/DashBoard/getBarGraphValues/${coveredEntities.coveredEntityID}`,
        payload,
        {
          hasDefaultURL: true,
          hideLoader: false,
        }
      );
      if (data) {
        setTop10Drugs(data.topNDCs)
      } else {
        setTop10Drugs([]);
      }
    } catch (error) { }

  };

  const handleEncounters = () => {
    let min = 1;
    let max = 100;
    let rand = min + Math.random() * (max - min);
    setRandNumber(rand);
    setIsOpen(!isOpen);
  }

  const drawerClose = () => {
    setIsOpen(!isOpen);
    // setDrawer("");
  }


  const handleReset = () => {

    setTop10Drugs([]);
    setInboundFaxCount([]);
    setOutboundFailedFaxCount([]);
    setOutboundFaxCount([]);
    setUnmappedFaxCount([]);
    setNetSavings([]);
    setMonths([]);
    setCounterData({
      "financialSummary": [
        {
          "name": "TestedClaims Claims",
          "value": "-",
          "iconName": "Tested Claims",
          "tooltip": "All claims that flowed from Contract Pharmacy to Referrals+ that appear in the system, regardless of the status.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "CE Receivables",
          "value": "-",
          "iconName": "CE Receivables",
          "tooltip": "The receivable value (Total Paid - Dispensing Fee) on approved or higher status claims.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "340B Drug Cost",
          "value": "-",
          "iconName": "340B Drug Cost",
          "tooltip": "The 340B Drug Cost on approved or higher status claims.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Profit Loss",
          "value": "-",
          "iconName": "Profit Loss",
          "tooltip": "The profit or loss (Total Paid - Dispensing Fee - 340B Drug Cost) on approved or higher status claims.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "RCS Fee",
          "value": "-",
          "iconName": "RCS Fee",
          "tooltip": "The calculated RCS fee on approved or higher status claims.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Net Savings",
          "value": "-",
          "iconName": "Net Savings",
          "tooltip": "The net savings (Total Paid - Dispensing Fee - 340B Drug Cost - RCS Fee) on approved or higher status claims.",
          "recordsCount": 0,
          "recentReceivedDate": null
        }
      ],
      "programHealth": [
        {
          "name": "Encounter",
          "value": "-",
          "iconName": "Encounter",
          "tooltip": "Displays Encounter data from the last 30 days, including successful and failed records.",
          "recordsCount": 0,
          "recentReceivedDate": ""
        },
        {
          "name": "Queued Claims",
          "value": "-",
          "iconName": "Queued Claims",
          "tooltip": " The number of claims that passed all rule checks and are in Queued status to review for eligibility.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Pending Claims",
          "value": "-",
          "iconName": "Pending Claims",
          "tooltip": "The number of claims pending an inbound fax from a provider's office.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Approved Claims",
          "value": "-",
          "iconName": "Approved Claims",
          "tooltip": "The number of claims that have been approved and are pending submission to Contract Pharmacy to capture.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Approved-Sent to TPA Claims",
          "value": "-",
          "iconName": "Approved-Sent to TPA Claims",
          "tooltip": "The number of claims that have been approved and sent to Contract Pharmacy to capture.",
          "recordsCount": 0,
          "recentReceivedDate": null
        },
        {
          "name": "Replenished Claims",
          "value": "-",
          "iconName": "Replenished Claims",
          "tooltip": "The number of claims that have been replenished.",
          "recordsCount": 0,
          "recentReceivedDate": null
        }
      ]
    })


  };

  return (
    <div>
      {loading && <Loader opacity={0.01} />}
      <div>
        <Container fluid className="width_info">
          <div>
            <ErrorBoundary>
              <Card className="border-0 shadow-top">
                <CardBody>
                  <SearchDashboard
                    onreset={handleReset}
                    orgId={orgId}
                    search={search}
                    searchTerms={searchTerms}
                    onSearch={onSearch}
                    selectsearch={selectsearch}
                    setSelectSearch={setSelectSearch}
                    startDateValue={startDateVAlue}
                    setStartdate={setStartDateValue}
                    endDateValue={endDateVAlue}
                    setEndDate={setEndDateValue}
                  />
                </CardBody>
              </Card>
            </ErrorBoundary>
          </div>
          <div>
            <Row sm={2} xs={1}>
              <Col md={12}>
                <Row>
                  <Col className="mt-3" md={7}>
                    {/* <ClaimCapturedRep
                        months={months}
                        capture={capture}
                        replenished={replenished}
                      /> */}
                    <Programover months={months} selectsearch={selectsearch} netSavings={netSavings} />
                  </Col>
                  <Col md={5}>
                    <Row>
                      <Col md={6} className="mt-3">
                        <Card
                          className="h-100 border-0 shadow-top"
                          style={{ borderRadius: "4px" }}
                        >
                          <CardHeader
                            className="border-0 bg-white"
                            style={{ borderRadius: "4px" }}
                          >
                            <Row className="align-items-center">
                              <Col className="d-flex justify-content-between">
                                <CardTitle className="f-20 font-weight-500 mb-0 scroll">
                                  Financial
                                  <span className="d-block">Summary</span>
                                </CardTitle>
                                <img src={FinacialIcon} />
                              </Col>
                            </Row>
                            <div className="mt-3" >
                              {counterData?.financialSummary?.map((item, index) => {
                                return (
                                  <div
                                    key={index}
                                    className="mt-3 border-btm-line"
                                  >
                                    <div className="finacial-heading">
                                      <CTooltip
                                        content={
                                          <div className="tip-list-info p">
                                            <p>{item?.tooltip}</p>
                                          </div>
                                        }
                                      >
                                        <span className="finacial-heading">
                                          {item.iconName}
                                        </span>
                                      </CTooltip>

                                    </div>
                                    <div className="finacial-value mt-2">
                                      {item?.value}
                                    </div>
                                    {/* <div className="border"></div> */}
                                  </div>
                                );
                              })}
                            </div>
                          </CardHeader>
                          {/* <CardBody className="dashboard-chart-body">
                              <div className="dashboard-chart-height"></div>
                            </CardBody> */}
                        </Card>
                      </Col>
                      <Col md={6} className="mt-3">
                        <Card
                          className="h-100 border-0 shadow-top"
                          style={{ borderRadius: "4px" }}
                        >
                          <CardHeader
                            className="border-0 bg-white"
                            style={{ borderRadius: "4px" }}
                          >
                            <Row className="align-items-center">
                              <Col className="d-flex justify-content-between">
                                <CardTitle className="f-20 font-weight-500 mb-0 scroll">
                                  Program
                                  <span className="d-block">Health</span>
                                </CardTitle>
                                <img src={DashboardProgram} />
                              </Col>
                            </Row>

                            <div className="mt-3">
                              {counterData?.programHealth?.map((item) => {
                                let imagevalue = "";
                                const currentDate = new Date();
                                const twoDaysAgo = new Date(currentDate);
                                twoDaysAgo.setDate(currentDate.getDate() - 2);
                                const threeDaysAgo = new Date(currentDate);
                                threeDaysAgo.setDate(currentDate.getDate() - 3);

                                const recentReceivedDate = new Date(
                                  item.recentReceivedDate
                                );

                                return (
                                  <div className="mt-3 border-btm-line">

                                    <div className="finacial-heading">
                                      <CTooltip
                                        content={
                                          <div className="tip-list-info p">
                                            <p>{item?.tooltip}</p>
                                          </div>
                                        }
                                      >
                                        <div className="finacial-heading d-flex justify-content-between  align-items-center">


                                          <span className="finacial-heading1 ">
                                            {item.iconName == "Encounter" && item.value != "-" ?

                                              <span
                                                className="cursor-pointer text-decoration-underline"
                                                onClick={() =>
                                                  togglesDrawer()
                                                }
                                              >
                                                {item.iconName}
                                              </span>
                                              :
                                              <span
                                                className=""

                                              >
                                                {item.iconName}
                                              </span>}

                                          </span>


                                          {item.iconName == "Encounter" &&
                                            <span className="finacial-heading1-1">
                                              Last Updated
                                            </span>
                                          }
                                        </div>
                                      </CTooltip>

                                      <div className="finacial-value mt-2 d-flex justify-content-between ">
                                        {item?.value}
                                        <span
                                          className="finacial-value1-1 f-600 "
                                        // style={{ paddingRight: "10px" }}
                                        >
                                          {item.iconName == "Encounter" && dateFormate(
                                            item.recentReceivedDate
                                          )}
                                        </span>





                                      </div>
                                    </div>
                                    {/* <div className="border"></div> */}

                                  </div>
                                );
                              })}
                            </div>
                          </CardHeader>
                          {/* <CardBody className="dashboard-chart-body">
                              <div className="dashboard-chart-height"></div>
                            </CardBody> */}
                        </Card>
                      </Col>
                    </Row>
                  </Col>
                </Row>
                <Row>
                  {/* <Col className="mt-3" md={6}>
                      <DrugSpend
                      selectsearch={selectsearch}

                      />
                    </Col> */}


                  <Col className="mt-3" md={6}>
                    <FaxOverview months={months} inboundFaxCount={inboundFaxCount} outboundFailedFaxCount={outboundFailedFaxCount} outboundFaxCount={outboundFaxCount} unmappedFaxCount={unmappedFaxCount} />
                  </Col>
                  <Col className="mt-3" md={6}>
                    <TopDrugs top10Drugs={top10Drugs} selectsearch={selectsearch} />
                  </Col>
                </Row>
              </Col>
            </Row>
          </div>
          <Drawer
            direction="end"
            title="Encounters"
            isOpen={drugutlization}
            toggle={togglesDrawer}
            size="lg"
          >

            <EncountersDrawer
              orgId={orgId}
              tenantID={coveredEntities.tenantID}
              onClose={drawerClose}
              randNum={randNum}
            />

          </Drawer>
        </Container>
      </div >
    </div >
  );
};

export default Dashboard;
